var render = function render(_c, _vm) {
  return _c(
    "section",
    {
      staticClass: "row roomy align-stretch margin-bottom-6xl",
      staticStyle: {
        "--fa-secondary-opacity": "1",
        "--fa-secondary-color": "var(--fa-teal)",
        "--card-background": "transparent",
        "--card-margin-bottom": "0",
      },
      attrs: { id: "other" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "column-12 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "article",
            {
              staticClass: "card roomy text-left",
              staticStyle: { height: "100%" },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-bottom-xs",
                attrs: {
                  icon: _vm.parent.$v6.duotone.faRankingStar,
                  size: "3x",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "h4 margin-top-0" }, [
                _vm._v("How does this all work?"),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c(
                    "site-link",
                    {
                      attrs: {
                        to: { name: "support", hash: "#requesting-icons" },
                      },
                    },
                    [_vm._v("We encourage new icon requests")]
                  ),
                  _vm._v(
                    "\n        through the Font Awesome GitHub community. Through community support, requests climb this leaderboard and often become official icons.\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "article",
            {
              staticClass: "card roomy text-left",
              staticStyle: { height: "100%" },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-bottom-xs",
                attrs: {
                  icon: _vm.parent.$v6.duotone.faBinoculars,
                  size: "3x",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "h4 margin-top-0" }, [
                _vm._v("Not finding a request?"),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "article",
            {
              staticClass: "card roomy text-left",
              staticStyle: { height: "100%" },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-bottom-xs",
                attrs: {
                  icon: _vm.parent.$v6.duotone.faCircleQuestion,
                  size: "3x",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "h4 margin-top-0" }, [
                _vm._v("Got a request question?"),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v(
                    "\n        Not sure about about something? Check out the\n        "
                  ),
                  _c(
                    "site-link",
                    {
                      attrs: {
                        to: {
                          name: "support",
                          hash: "#i-want-an-icon-to-be-added-to-font-awesome",
                        },
                      },
                    },
                    [_vm._v("answers to common icon request questions")]
                  ),
                  _vm._v(".\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c("p", [
      _vm._v(
        "\n        A request may not have the community support to be ranked high enough to make it onto this leaderboard. But you can\n        "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/FortAwesome/Font-Awesome/labels/new%20icon",
            target: "_blank",
          },
        },
        [_vm._v("find it by viewing all icon requests")]
      ),
      _vm._v(".\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }